module.exports = __webpack_public_path__ + "static/media/icon-arrow-down.1dd98537.svg";